import { Star, StarFill } from "react-bootstrap-icons";
import { t } from "./auctionI18n";

// Star toggle for the bidder watchlist. `watched` drives the icon; `onToggle`
// fires on click. `compact` renders an icon-only round button (for queue rows /
// cards); otherwise it shows a labelled pill.
const WatchButton = ({ watched, onToggle, compact = false, className = "" }) => {
    const title = watched
        ? t("რჩეულებიდან მოხსნა", "Remove from favorites", "Убрать из избранного", "Հեռացնել ընտրանուց")
        : t("რჩეულებში დამატება", "Add to favorites", "Добавить в избранное", "Ավելացնել ընտրանի");
    return (
        <button
            type="button"
            className={`auction-watch-btn ${compact ? "is-compact" : ""} ${watched ? "is-on" : ""} ${className}`}
            aria-pressed={watched}
            title={title}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onToggle(); }}
        >
            {watched ? <StarFill /> : <Star />}
            {!compact && <span>{watched ? t("რჩეულებშია", "In favorites", "В избранном", "Ընտրանիում") : t("რჩეულებში", "Favorite", "В избранное", "Ընտրանի")}</span>}
        </button>
    );
};

export default WatchButton;
